<template>
  <!-- 示例预览 -->
  <div v-if="fileUrl" class="preview_box">
    <img class="preview_box_image" :src="fileUrl" />
    <div class="preview">
      <div class="preview_item" v-for="item in msg" :key="item">{{ item }}</div>
      <div class="preview_exit"><span @click="() => (fileUrl = '')" class="preview_exit_btn">退出示例</span></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "preview",
  props: {
    fileUrl: {
      type: String,
      default: ""
    },
    msg: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style scoped>
.preview_box {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  height: 100%;
  z-index: 9999;
  background: #fff;
  overflow: auto;
}
.preview_box_image {
  width: 100%;
}
.preview {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  min-height: 1.5rem;
  background: rgba(0, 0, 0, 0.5);
  color: #fff;
  font-size: 0.12rem;
  text-align: left;
  padding: 0.25rem;
  overflow: hidden;
  box-sizing: border-box;
}
.preview_item {
  line-height: 0.22rem;
}
.preview_exit {
  text-align: center;
}
.preview_exit_btn {
  border: 1px solid #fff;
  border-radius: 0.3rem;
  display: inline-block;
  padding: 0 0.3rem;
  margin-top: 0.1rem;
  line-height: 0.32rem;
}
</style>
